import packageJson from "../../package.json";

export default {
  player: {
    timeToHideUI: 7000,
    timeToShowPauseScreen: 7000,
    nextEpisodeCountDown: 5,
    loadTimeout: 60000,
    bufferingTimeout: 60000,
    playbackPercentages: [0, 0.25, 0.5, 0.75, 0.9],
    playbackRates: {
      1: 500,
      2: 250,
      3: 125
    },
    streamingTechnology: "dash",
    drmTechnology: "widevine",
    skipOutroCountDown: 5,
    preferredSubtitlesLanguage: "en"
  },
  featureToggles: {
    maxDevices: true,
    filmstrip: true,
    eVoucher: true,
    analytics: true,
    playbackAnalytics: {
      trailerFixedDuration: 120
    },
    exitAppPopup: true,
    backToTop: {
      carouselToShowBack: 3
    },
    remoteLocales: false,
    skipIntro: true,
    skipOutro: true
  },
  layouts: {
    modulesPageSize: 7
  },
  minPassLength: 6,
  authenticationKey: "STARZPLAYappSECRET", // Besides, find a better way to protect the user data.
  locales: {
    en: {
      direction: "ltr",
      separator: ","
    },
    ar: {
      direction: "rtl",
      separator: "،"
    }
  },
  sdk: {
    defaultLocale: "en",
    networkRequestsTimeout: 60000,
    supportedLanguages: ["en", "fr", "ar", "hi", "ur", "ta", "ml", "te", "pa", "mr", "bn", "bho", "gu", "kn"],
    backendHosts: {
      auth: "https://app-api.starzplay.com/api/auth",
      media: "https://app-api.starzplay.com/api/media",
      settings: "https://app-api.starzplay.com/api/settings",
      reports: "https://app-api.starzplay.com/api/reports",
      payments: "https://app-api.starzplay.com/api/payments",
      staticMedia: "https://static-app-api.starzplay.com/api/media",
      spxV1_0: "https://api.aws.playco.com/api/v1.0",
      spxV1: "https://api.aws.playco.com/api/v1.1",
      spxV2: "",
      nmsV1: "https://sp-new-api.aws.playco.com/api/v1.0",
      nmsV2: "https://sp-new-api.aws.playco.com/api/v1.1",
      "mpxV1 ": "",
      mpxV2: ""
    },
    localCache: {
      auth: true,
      layouts: true,
      titles: true,
      search: true,
      feeds: true,
      genres: true,
      devices: true,
      preferences: true,
      memoryCache: true,
      mops: true,
      allSubscriptionDeepQuery: true,
      epgConfigs: true,
      startEpgEvents: true,
      categoryEvents: true,
      paymentMethodDictionary: false
    },
    shuffleLayoutStaticModules: false,
    layoutCacheTime: 21600000, // 6 hours
    titlesCacheTime: 10800000,
    seasonsCacheTime: 7200000,
    heartbeatPeriod: 25000,
    episodesCacheTime: 300000,
    genresCacheTime: 172800000,
    feedsCacheTime: 7200000,
    devicesCacheTime: 3600000,
    userPreferencesCacheTime: 900000,
    memoryCacheLimit: 5242880,
    minimumCacheCleanupTime: 300000,
    tokenExpirationTime: 10000 * 365 * 24 * 60 * 60,
    filmstripsTimeJump: 10000,
    autoFullScreenTimer: 900000, // 15mins
    drmTechnology: "widevine",
    drmLicenseServer: "http://playready-license.drm.technology/rightsmanager.asmx",
    platformName: "smarttv",
    maxUserDevices: 5,
    appVersion: packageJson.version,
    publicVersion: "4.0.0", // This version is for use by teams other than dev
    appName: "HisenseTV",
    clientType: "hisense-vidaa",
    deviceName: "HISENSE TV",
    deviceType: "hisensetv",
    initialBitrateHD: 650000,
    initialBitrate4K: 850000,
    initialBitrateTrailer: 1700000,
    multipleProfiles: {
      headers: {
        X_PROFILE_ID: "x-profile-id",
        X_PROFILE_CATEGORY: "x-profile-category"
      }
    },
    playbackAnalytics: {
      accountCode: "parsifalentertainment",
      enableAnalytics: true,
      httpSecure: true,
      libSrc: "https://smartplugin.youbora.com/v6/js/adapters/bitmovin8/6.8.1/sp.min.js"
    },
    analyticsId: "UA-52364929-21" // NOTE: Current analyticsId is the one used for DEVELOPMENT purposes. The one to be used for PRODUCTION is "UA-52364929-33".
  },
  settingsSubsections: [
    {
      name: "accountDetails",
      showInLoggedInState: true,
      showInLoggedOutState: true,
      isForKids: true
    },
    {
      name: "manageProfile",
      showInLoggedInState: true,
      showInLoggedOutState: true,
      isForKids: true
    },
    {
      name: "devices",
      showInLoggedInState: true,
      showInLoggedOutState: false,
      isForKids: false
    },
    {
      name: "history",
      showInLoggedInState: true,
      showInLoggedOutState: false,
      isForKids: false
    },
    {
      name: "help",
      showInLoggedInState: true,
      showInLoggedOutState: true,
      isForKids: true
    },
    {
      name: "eVoucher",
      onlyLoggedIn: false,
      minimumParentalLevel: "1"
    },
    {
      name: "logout",
      showInLoggedInState: true,
      showInLoggedOutState: false,
      isForKids: false
    },
    {
      name: "login",
      showInLoggedInState: false,
      showInLoggedOutState: true,
      isForKids: false
    }
  ],
  parentalControlList: ["1", "7", "15", "18"],
  limitedAppAccessParentalLevel: 1,
  unlimitedAppAccessParentalLevel: 18,
  allowedCountries: [
    { code: "DZ" },
    { code: "BH" },
    { code: "DJ" },
    { code: "EG" },
    { code: "IQ" },
    { code: "JO" },
    { code: "KW" },
    { code: "LB" },
    { code: "LY" },
    { code: "MR" },
    { code: "MA" },
    { code: "OM" },
    { code: "PS" },
    { code: "QA" },
    { code: "SA" },
    { code: "SS" },
    { code: "TN" },
    { code: "AE" },
    { code: "YE" },
    { code: "IN" },
    { code: "KR" },
    { code: "ES" },
    { code: "PK" }
  ],
  geoblockingTimeout: 20000,
  defaultGenresMenuItems: [
    {
      name: "lastAdded",
      sort: "lastAdded"
    },
    {
      name: "alphabetical",
      sort: "alphabetical"
    }
  ],
  ui: {
    urlCdn: "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images",
    animations: false,
    throttle: {
      high: 75,
      medium: 150,
      low: 300
    }
  },
  debug: {
    enabled: false,
    overlay: {
      height: "100%",
      lines: 40,
      opacity: 0.6
    }
  },
  unmanagedPaymentPlans: ["cedarcom_lb", "ooredooTv_qa", "ooredooApp_qa", "apple_iap", "anghami_lb"],
  myLibraryFilterMenuItems: [],
  addonNames: {
    "discovery+": "discovery"
  },
  buyAssetOrBrand: {
    pollingTime: 30000
  },
  rentDisclaimerTime: {
    hours: 48,
    days: 30
  },
  screenSaver: {
    SCREENSAVER_ENABLED_KEY: true,
    SCREENSAVER_IDLE_TIME_KEY: 240000,
    SCREENSAVER_ARTWORKS_PATH_KEY:
      "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/screensaver/index1.html"
  },
  promptCdnConfig:
    "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/resources/data/hisense/globalConfig.json",
  avod: {
    prompt: {
      signup: {
        active: true,
        time: "00:05:00",
        features: {
          icons: [
            "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/icon1.png",
            "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/icon2.png",
            "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/icon3.png"
          ]
        }
      },
      premium: {
        active: true,
        time: "00:05:00",
        features: {
          icons: [
            "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/check1.png",
            "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/check2.png",
            "https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/icons/check3.png"
          ]
        }
      }
    },
    onboarding: {
      guest: {
        defaultLanding: "home"
      },
      loggedin: {
        defaultLanding: "home"
      }
    },
    widevine: {
      LA_URL_default: "https://widevine-license.vudrm.tech/proxy"
    },
    isChampionsTrophyEnabled: true,
    search: {
      delay: 2000,
      queryMinCharacters: {
        default: 2 // The search minimum characters limit could be specified by language [en, ar]
      }
    }
  },
  remoteConfig: "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/configs/remote-configs.json",
  profileScreenBackGround: "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/configs/profiles-screen.json",
  sponsorAds: {
    bug: {
      URL: "/23010729658/STARZON/bug",
      size: "250x50"
    },
    pauseAd: {
      URL: "/23010729658/STARZON/pause",
      size: "2x2"
    }
  },
  concurrency: {
    defaultValue: 2
  },
  remoteConfigFallback: {
    heartbeat_config: {
      AVOD: 90,
      SVOD: 90,
      TVOD: 90
    }
  }
};
